import { render, staticRenderFns } from "./LaborCostList.vue?vue&type=template&id=5cbbd0cf&"
import script from "./LaborCostList.vue?vue&type=script&lang=js&"
export * from "./LaborCostList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports